import React from 'react';
import _ from 'lodash';

import ResourcePage from '../../js/pages/ResourcePage';
import CMS from '../../../server/services/cms';
import {hasPremiumAccess} from '../../../server/routes/util';

export default function Page(props) {
  return <ResourcePage {...props} />;
}

export async function getServerSideProps({req, params}) {
  const {slug} = params;

  // Fetch resource content
  const resource = await CMS.getResource(slug);
  if (!resource) return {notFound: true};

  // Check if the visitor has access to this lesson (member or free lesson)
  const hasAccess = resource.free || await hasPremiumAccess(req);

  // Update content visibility based on user access
  if (!hasAccess) {
    resource.intro = _.truncate(resource.intro, {length: 300});
    resource.content = _.truncate(resource.content, {length: 300});
    resource.paywalledVideo = Boolean(resource.video || resource.soundcloud);
    resource.video = null;
    resource.soundcloud = null;
  }

  return {
    props: {
      resource: JSON.parse(JSON.stringify(resource)),
      hasAccess,
    },
  };
}


